import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'numberSuffix'
})
export class NumberSuffixPipe implements PipeTransform {
  private readonly suffixes = ['', 'K', 'M', 'G', 'T', 'P', 'E'];

  constructor(private currencyPipe: CurrencyPipe) {}

  public transform(value: number, asCurrency = false): string | null {
    if (value === null || value === undefined || isNaN(value)) {
      return null; // Handle invalid input
    }

    const isNegative = value < 0;
    const absoluteValue = Math.abs(value);

    if (absoluteValue < 1000) {
      // No suffix needed for values less than 1000
      return asCurrency
        ? this.currencyPipe.transform(value, '', 'symbol', '1.0-0')
        : value.toString();
    }

    // Determine the appropriate suffix
    const exp = Math.floor(Math.log(absoluteValue) / Math.log(1000));
    const smallNumber =
      (absoluteValue / Math.pow(1000, exp)) * (isNegative ? -1 : 1);

    // Format the result
    const formattedNumber = asCurrency
      ? this.currencyPipe.transform(smallNumber, '', 'symbol', '1.0-0')
      : smallNumber.toFixed(1); // Keep one decimal place for non-currency

    return `${formattedNumber}${this.suffixes[exp]}`;
  }
}
